export default "__VITE_ASSET__DMQQZC12__"